module.exports = __webpack_public_path__ + "static/img/cDR4.34dc0372.png";